import { observer } from "mobx-react-lite";
import inputStyles from "./inputs/Input.module.css";

function RadiusDropdown({ value, onChange }: IRadiusDropdoownProps) {
    return (
        <div className={inputStyles.container}>
            <select value={value} onChange={e => onChange(Number(e.target.value))}>
                <option value={1}>1 miles</option>
                <option value={5}>5 miles</option>
                <option value={10}>10 miles</option>
                <option value={15}>15 miles</option>
                <option value={25}>25 miles</option>
                <option value={50}>50 miles</option>
            </select>
        </div>
    );
}

export default observer(RadiusDropdown);

interface IRadiusDropdoownProps {
    value: number;
    onChange: (value: number) => void;
}